import { lazy } from "react";
import { Route } from "react-router-dom";

const AgreementsTableRoot = lazy(() => import("../../containers/agreements/AgreementsTableRoot"));
const AgreementDetails = lazy(() => import("../../containers/agreements/agreement/Overview"));

const local21Routes = (link: string) => [{ key: "2.1.1", link: link + "/", component: (props: any) => <AgreementsTableRoot {...props} /> }];

export default function Key21Routes(key: string, link: string) {
	const key21Routes = [
		{ key: key, link: link + "/agreement/", component: (props: any) => <AgreementDetails {...props} /> },
		...local21Routes(link),
	];

	return key21Routes.map((r) => <Route exact key={r.key} path={r.link} render={r.component} />);
}
